module.exports = __webpack_public_path__ + "img/big-circle.e0f2f0ca.svg";